/* eslint-disable no-use-before-define */ import _ from 'lodash';
import { safeToBig } from 'shared/helpers/utils_math';
import { getProductVolumeInFluidOunces } from 'shared/helpers/products';
import { getFlowerEquivalent } from 'shared/helpers/check-limits';
import { getTypeLimits, getLimitMessage, getEffectiveSubcategories } from '../utils';
export function isLiquidEdible(product, limits) {
    var useMultiSubcategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var type = product.type;
    var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
    var liquidEdibleTypes = limits.liquidEdibleTypes;
    return _.intersection(liquidEdibleTypes === null || liquidEdibleTypes === void 0 ? void 0 : liquidEdibleTypes.subcategories, subcategories).length > 0 || _.includes(liquidEdibleTypes === null || liquidEdibleTypes === void 0 ? void 0 : liquidEdibleTypes.categories, type);
}
export function checkLiquidEdibleVolume(cart) {
    var state = cart.state;
    var liquidEdibleVolumeLimitInOunces = getTypeLimits(cart).liquidEdibleVolumeLimitInOunces;
    var totalVolumeInOunces = getTotalVolumeInOuncesForCart(cart);
    var message = getLimitMessage('liquid edibles', liquidEdibleVolumeLimitInOunces, state, 'oz');
    return totalVolumeInOunces > liquidEdibleVolumeLimitInOunces ? {
        total: totalVolumeInOunces,
        message: message,
        withinLimits: false
    } : {
        withinLimits: true
    };
}
export function getTotalVolumeInOuncesForCart(param) {
    var orders = param.orders, limits = param.limits, state = param.state, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var product = order.product, quantity = order.quantity;
        if (!isLiquidEdible(product, limits, useMultiSubcategories)) {
            return previous;
        }
        var volume = getProductVolumeInFluidOunces(product);
        var totalVolumeForOrder = safeToBig(volume).times(quantity).round(5);
        var isBritishColumbiaDispensary = state === 'BC';
        var flowerEquivalent = getFlowerEquivalent(order, medical, limits, useMultiSubcategories);
        var useEquivalent = isBritishColumbiaDispensary && !!flowerEquivalent;
        return safeToBig(previous).plus(useEquivalent ? flowerEquivalent : totalVolumeForOrder);
    }, 0.0));
}
